import DiscoverIconSM from "@/components/DiscoverIconSm";
import { Center, Container, Heading, Text } from "@chakra-ui/react";
import Head from "next/head";
import Link from "next/link";

export default function GetApp() {
  return (
    <>
      <Head>
        <title>Songcards for iOS and Android</title>
        <link rel="icon" href="/songcards.png" />
        <meta
          name="description"
          content="Download the free Songcards app for iOS and Android to listen,
            discover, and collect on the go."
        />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta itemProp="image" content="https://songcards.io/sc-pink.png" />
        <link rel="canonical" href={`https://songcards.io/get-app`} />
        {/* <link rel="apple-touch-icon" href="/SC Icon_A_Light.svg" /> */}
        <meta property="og:image" content="https://songcards.io/sc-pink.png" />
        <meta property="og:url" content="https://songcards.io/get-app" />
        <meta property="og:type" content="website" />
        <meta
          property="og:title"
          content="Songcards: Listen | Discover | Collect"
        />
        <meta
          property="og:description"
          content="Download the free Songcards app for iOS and Android to listen,
            discover, and collect on the go."
        />
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Songcards: Listen | Discover | Collect"
        />
        <meta
          name="twitter:description"
          content="Download the free Songcards app for iOS and Android to listen,
            discover, and collect on the go."
        />
        <meta name="twitter:image" content="https://songcards.io/sc-pink.png" />
        <meta name="apple-itunes-app" content="app-id=6737206374" />
      </Head>
      <Container mb={200}>
        <Heading mb={6} as={"h1"} textAlign="center">
          Songcards for iOS and Android
        </Heading>
        <Center>
          <Text textAlign="center" mb={1} maxW={"sm"} fontSize="md">
            Download the free Songcards app for iOS and Android to listen,
            discover, and collect on the go.
          </Text>
        </Center>
        <Center mt={0} mb={10}>
          <a
            href="https://apps.apple.com/us/app/songcards/id6737206374?itscg=30200&itsct=apps_box_badge&mttnsubad=6737206374"
            style={{ display: "inlineBlock" }}
            target="_blank"
          >
            <img
              src="https://toolbox.marketingtools.apple.com/api/v2/badges/download-on-the-app-store/black/en-us?releaseDate=1733443200"
              alt="Download on the App Store"
              style={{
                width: 123,
                height: 41,
                verticalAlign: "middle",
                objectFit: "contain",
              }}
            />
          </a>
          <a
            target="_blank"
            href="https://play.google.com/store/apps/details?id=com.songcards.songcards&hl=en&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1"
          >
            <img
              alt="Get it on Google Play"
              src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png"
              style={{
                width: 155,
                height: 100,
                verticalAlign: "middle",
                objectFit: "contain",
              }}
            />
          </a>
        </Center>
        {/* <SongcardDescription /> */}
        <Heading>Listen</Heading>
        <br />
        <Text>
          The Songcards app features a built-in music player so you can enjoy
          your collection on the go.
        </Text>
        <br />
        <Heading>Discover</Heading>
        <br />
        <Text>
          When you discover a Songcard link in the wild or here in the app, you
          can buy it instantly and add it to your collection.
          <br />
          <br />
          You will also find an ever-growing range of undiscovered artists in
          the Featured Page of the app and The Digital Collector{`'`}s Club
          newsletter.
        </Text>
        <br />
        <Heading>Collect</Heading>
        <br />
        <Text>
          Purchase music easily in the Songcards app and get instant access to
          your collection. Seamlessly add songs to the playback queue for
          non-stop listening.
        </Text>
        <br />
        <Heading>Share</Heading>
        <br />
        <Text>
          As you build your collection, you build your identity as a music
          collector and curator.
          <br />
          <br />
          You can show off your collection via your personal QR code or your
          collector link. By doing this you also help promote the artists you
          love.
        </Text>
        <br />
        <Heading>for Artists</Heading>
        <br />
        <Text>
          If you are a music maker and would like to create and list your own
          songcards, head over to{" "}
          <Link href="https://artists.songcards.io" target="_blank">
            <u>https://artists.songcards.io</u>
          </Link>
        </Text>
        <br />
        <Heading>What is a songcard?</Heading>
        <br />
        <Text>
          Songcards are a new format for digital music.
          <br />
          <br />
          Think of them as deluxe edition singles.
          <br />
          <br />
          It{`’`}s a way for artists to turn a song into a unique digital
          experience.
          <br />
          <br />
          Not only do they unlock MP3 and WAV downloads of the song, but
          collectors can access all manner of exclusive material offered by the
          artist.
          <br />
          <br />
          Some artists have included items such as lyric sheets, desktop
          wallpapers, and behind-the-scenes footage.
          <br />
          <br />
          When you buy a songcard, it gets delivered to the app directly. From
          there you{`'`}ll be able to access all of its features.
          <br />
          <br />
          Songcards is a new format for digital music, aiming at providing fans
          a way to unlock experiences offered by their favourite musicians.
        </Text>
        <br />

        <br />
        <Center mt={5} mb={5}>
          <a
            href="https://apps.apple.com/us/app/songcards/id6737206374?itscg=30200&itsct=apps_box_badge&mttnsubad=6737206374"
            style={{ display: "inlineBlock" }}
            target="_blank"
          >
            <img
              src="https://toolbox.marketingtools.apple.com/api/v2/badges/download-on-the-app-store/black/en-us?releaseDate=1733443200"
              alt="Download on the App Store"
              style={{
                width: 123,
                height: 41,
                verticalAlign: "middle",
                objectFit: "contain",
              }}
            />
          </a>
          <a
            target="_blank"
            href="https://play.google.com/store/apps/details?id=com.songcards.songcards&hl=en&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1"
          >
            <img
              alt="Get it on Google Play"
              src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png"
              style={{
                width: 155,
                height: 100,
                verticalAlign: "middle",
                objectFit: "contain",
              }}
            />
          </a>
        </Center>
        <br />
        <DiscoverIconSM />
      </Container>
    </>
  );
}
